import React, { useEffect, useRef } from "react";
import styles from "../components/comp_css/chapter_58.module.css";
import { Link } from "@mui/material";
import { useRouter } from "next/router";
import Common_html from "./Common_html";
import BlockData from "../../../central-doctraine-json/chapter64.json";
import Head from "next/head";
export default function Chapter_64() {

  const router = useRouter()
  const location = useRouter();
  const { pathname } = location;

  // const corosalref = useRef()

  // useEffect(() => {
  //     if (corosalref.current) {
  //         corosalref.current.scrollIntoView({
  //             behavior: "smooth",
  //             block: "nearest",
  //             inline: "start"
  //         })
  //     }
  //     console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])
  return (
    <>
     <Head>
        <title>Central Doctrine | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Iamblichus rejected Goetic coercion, teaching theurgy for divine union through alignment with cosmic elemental forces."
        ></meta>
        <meta
          property="og:title"
          content="Iamblichus’s Theurgy and the Misinterpretation of Goetic Traditions"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="og:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          property="og:description"
          content="Contrary to modern claims, Iamblichus never outlined Goetic demon typologies or summoning practices. His theurgy sought divine union, not coercion, and opposed manipulative magic. Misreading his works as precursors to the Lemegeton distorts Neoplatonic philosophy. Iamblichus described elemental beings for spiritual alignment, rejecting the grotesque forms and binding rituals of later Goetic grimoires."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=64"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta
          property="twitter:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="twitter:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          name="twitter:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=64"
        ></meta>
        <meta
          name="twitter:title"
          content="Iamblichus’s Theurgy and the Misinterpretation of Goetic Traditions"
        ></meta>
        <meta
          name="twitter:description"
          content="Iamblichus’s theurgy embraced alignment with the divine, not Goetic coercion. Claims linking him to Lemegeton demons distort his philosophy. He described elemental beings as part of cosmic harmony, opposing manipulative summoning or binding. Theurgy’s aim was purification and unity with the One, a vision wholly incompatible with Goetic magical traditions and their demon catalogs."
        ></meta>
        <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=64" />
      </Head>
      <Common_html BlockData={BlockData} />
    </>
  );
}
